// Vendor Libs
import React, {useEffect} from 'react';

// Material UI
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import {makeStyles} from '@material-ui/core/styles';

// Dish Tech React
import {Overlay} from '@dishtech-react/core';
import {useOverlay, useService} from '@dishtech-react/hooks';
import {GetRippleRoles, areRolesAuthorized} from '@dishtech-react/utils';

// Components
import MultiContainerDragNDrop from './multi-container-drag-and-drop';
import StorefrontForm from './storefront-form';

// Hooks
import {useStorefront} from '../../hooks/use-storefront';

const useStyles = makeStyles(_theme => ({
  addButton: {
    position: 'fixed',
    top: '96px',
    right: '32px',
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    minWidth: '1000px',
    justifyContent: 'center',
  },
}));

const SERVICE_KEY = 'STOREFRONT';

const Storefront = () => {
  const rippleRoles = GetRippleRoles();
  const classes = useStyles();

  const {closeOverlay: closeCreateOverlay, overlayId: createOverlayId} = useOverlay({
    id: 'storefront_create',
  });

  const {closeOverlay: closeUpdateOverlay, overlayId: updateOverlayId} = useOverlay({
    id: 'storefront_update',
  });

  const {serviceContent: storefronts, registerService, unregisterService} = useService(SERVICE_KEY);
  const {createStorefront, mode, updateStorefront} = useStorefront();

  useEffect(() => {
    if (areRolesAuthorized(rippleRoles, 'STOREFRONT', ['CREATE', 'DELETE', 'READ', 'UPDATE'])) {
      registerService();

      return () => unregisterService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = storefrontData => {
    updateStorefront(storefrontData);
  };

  const onAddClick = () => {
    createStorefront();
  };

  return (
    <div className={classes.container}>
      <MultiContainerDragNDrop
        data={storefronts}
        dropDisabled={!areRolesAuthorized(rippleRoles, 'STOREFRONT', ['UPDATE'])}
        onClick={onClick}
      />
      {mode === 'create' ? (
        <Overlay id={createOverlayId} title="Create Storefront" wide={true}>
          <StorefrontForm onCancel={closeCreateOverlay} onSave={closeCreateOverlay} />
        </Overlay>
      ) : null}
      {mode === 'update' && areRolesAuthorized(rippleRoles, 'STOREFRONT', ['UPDATE']) ? (
        <Overlay id={updateOverlayId} title="Update Storefront" wide={true}>
          <StorefrontForm rippleRoles={rippleRoles} onCancel={closeUpdateOverlay} onSave={closeUpdateOverlay} />
        </Overlay>
      ) : null}
      <Fab
        className={classes.addButton}
        color="primary"
        disabled={!areRolesAuthorized(rippleRoles, 'STOREFRONT', ['CREATE'])}
        size="medium"
        onClick={onAddClick}
      >
        <AddIcon />
      </Fab>
    </div>
  );
};

export default Storefront;
